import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Badge } from 'primereact/badge';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

// Column
import { AddressChangeColumns } from '../../../appconfig/DatatableSetting';

// Data table
import { defaultRowOptions, defaultPageRowOptions, Skeletonitems, SkeletonbodyTemplate, paginatorLinks, showingEntries, DataStatusOptions, ADDRESSCHANGENAME } from '../../../appconfig/Settings';

//Services
import { getAllDetails } from '../../../service/ProductService';

import { APPROVEOTHERAPP, GET_ADDRESSCHANGELIST } from '../../../config/ApiConstant';
import moment from 'moment';
import { ApplicationTab } from '../applicationTab';
import { OtherApplicationTab } from './OtherApplicationTab';
import { applicationsFullNameTemplate, verifiedByTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { formatDateTime, setOtherAppStatus } from '../../../appconfig/AppHelper';
import ApprovalModal from '../../../components/Modal/ApprovalModal';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const AddressChange = () => {
    document.title = 'Address Change | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);
    const [searchVal, setSearchVal] = useState<any>(null);

    // Date Object
    const storedDates = localStorage.getItem('address_app');
    let initialStartDate = moment().subtract(30, 'days').toDate();
    let initialEndDate = moment().toDate();

    if (storedDates) {
        try {
            const parsed = JSON.parse(storedDates);
            initialStartDate = parsed.startDate ? new Date(parsed.startDate) : initialStartDate;
            initialEndDate = parsed.endDate ? new Date(parsed.endDate) : initialEndDate;
        } catch (error) {
            console.error('Error parsing stored dates', error);
        }
    }

    const [dates, setDates] = useState({
        start: initialStartDate,
        end: initialEndDate
    });

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [applicationsList, setApplicationsList] = useState<any>([]);
    const [appStatusFilter, setAppStatusFilter] = useState<any>({ name: 'All', code: 'All' });
    const [approveModal, setApproveModal] = useState<boolean>(false);
    const [approveLoader, setApproveLoader] = useState<boolean>(false);
    const [approveId, setApproveId] = useState<any>(null);
    const [changeStatusModal, setChangeStatusModal] = useState<boolean>(false);
    const [changeStatusId, setChangeStatusId] = useState<any>(null);

    // useEffect
    useEffect(() => {
        getAllAddressChangeApplication();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [dates]);

    // Get all address change application
    const getAllAddressChangeApplication = async () => {
        try {
            setPageLoad(false);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            const response = await getAllDetails(GET_ADDRESSCHANGELIST + '?start_date=' + startDate + '&end_date=' + endDate + '&search=' + searchVal);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setApplicationsList([]);
                } else {
                    setApplicationsList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setApplicationsList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setApplicationsList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="block mt-2 md:mt-0 p-input-icon-left mr-3">
                    <i className="pi pi-search"></i>
                    <InputText value={searchVal} onChange={(e) => setSearchVal(e.target.value)} placeholder="Search..." className="" />
                    <i className="pi pi-times input-s" onClick={() => removeSearch()} style={{ right: '10px', zIndex: '111111', cursor: 'pointer' }}></i>
                </span>

                <Button label="" icon="pi pi-search" className="p-button p-button-rounded" onClick={() => getAllAddressChangeApplication()} />
            </>
        );
    };

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });

        if (start && end) {
            localStorage.setItem(
                'address_app',
                JSON.stringify({
                    startDate: moment(start).format('YYYY-MM-DD'),
                    endDate: moment(end).format('YYYY-MM-DD')
                })
            );
        }
    };

    //remove serach
    const removeSearch = () => {
        setSearchVal(null);
        setGlobalFilter(null);
        getAllAddressChangeApplication();
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setAppStatusFilter({ name: 'All', code: 'All' });
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    // Search by app status
    const searchByAppStatus = (options: any) => {
        return (
            <Dropdown
                filter
                value={appStatusFilter}
                onChange={(e: any) => {
                    setAppStatusFilter(e.value);
                    options.filterCallback(e.value.code, options.index);
                }}
                options={DataStatusOptions}
                optionLabel="name"
                placeholder="Search By Status"
                className="order-drp"
            ></Dropdown>
        );
    };

    // Template for comment
    const commentTemplate = (rowData: any) => {
        let appStatusVal = setOtherAppStatus(rowData.add_status);
        return (
            <>
                {appStatusVal.value === 'Rejected' || appStatusVal.value === 'Hold' ? (
                    <Button tooltip={rowData?.comment} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                        <div className="college-name-div">{rowData.comment}</div>
                    </Button>
                ) : (
                    '-'
                )}
            </>
        );
    };

    // Template for status
    const statusTemplate = (rowData: any) => {
        let appStatusVal = setOtherAppStatus(rowData.add_status);
        return (
            <>
                <Badge severity={appStatusVal.severity} value={appStatusVal.value}></Badge>
            </>
        );
    };

    // Template for new address
    const newAddressTemplate = (rowData: any) => {
        return (
            <>
                <Button tooltip={rowData?.new_address} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">{!window.cn(rowData.new_address) ? rowData.new_address : ''}</div>
                </Button>
            </>
        );
    };

    // Template for application date
    const applicationDateTemplate = (rowData: any) => {
        return <>{!window.cn(rowData.ApplicationDate) ? formatDateTime(rowData.ApplicationDate) : '-'}</>;
    };

    // Template for actions
    const actionsTemplate = (rowData: any) => {
        let appStatusVal = setOtherAppStatus(rowData.add_status);
        return (
            <>
                <div className="actions action-btn">
                    <Button tooltip="View" tooltipOptions={{ position: 'top' }} icon="pi pi-eye" className="ml-2" onClick={() => onViewDoc(rowData?.document_url)} />
                    <Button
                        tooltip="Approve"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-arrow-up-right"
                        className="p-button-success ml-2"
                        onClick={() => openApproveModal(rowData.EntNo)}
                        disabled={appStatusVal.value === 'Approved' ? true : false}
                    />
                    <Button
                        tooltip="Change Status"
                        tooltipOptions={{ position: 'top' }}
                        icon="fa-solid fa-rotate"
                        className="p-button-info ml-2"
                        onClick={() => openChangeStatusModal(rowData.EntNo)}
                        disabled={appStatusVal.value === 'Approved' ? true : false}
                    />
                </div>
            </>
        );
    };

    // On row select action
    const onViewDoc = (document_url: any) => {
        let fileExtension = false;
        if (!window.cn(document_url)) {
            var fileLastExtension = document_url.substr(document_url.lastIndexOf('/') + 1);
            let finalExtension = fileLastExtension.substr(fileLastExtension.lastIndexOf('.') + 1);
            if (finalExtension.toLowerCase() === 'pdf') {
                fileExtension = true;
            }

            //PDF Download
            let fileName: any;
            if (fileExtension) {
                fileName = `Document-Detail-${new Date().getTime()}.pdf`;
            } else {
                fileName = `Document-Detail-${new Date().getTime()}.${finalExtension.toLowerCase()}`;
            }
            const link = document.createElement('a');
            link.href = document_url;
            link.target = '_blank';
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
        } else {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'No File Uploaded'
            });
        }
    };

    // Open approve modal
    const openApproveModal = (id: any) => {
        setApproveId(id);
        setApproveModal(true);
    };

    // Close approve modal
    const closeApproveModal = () => {
        setApproveId(null);
        setApproveLoader(false);
        setApproveModal(false);
    };

    // On approve application
    const onApproveApplication = async () => {
        try {
            setApproveLoader(true);

            let formData: any = new FormData();
            const verifiedBy = localStorage.getItem('name');

            const response = await getAllDetails(APPROVEOTHERAPP + '?id=' + approveId + '&AppName=' + ADDRESSCHANGENAME + '&verified_by=' + verifiedBy);
            if (response) {
                setApproveLoader(false);
                setApproveModal(false);
                setApproveId(null);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Message',
                    detail: response
                });
                setTimeout(() => {
                    getAllAddressChangeApplication();
                }, 1500);
            }
        } catch (error: any) {
            setApproveLoader(false);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Open change status modal
    const openChangeStatusModal = (id: any) => {
        setChangeStatusId(id);
        setChangeStatusModal(true);
    };

    // Close change status modal
    const closeChangeStatusModal = () => {
        getAllAddressChangeApplication();
        setChangeStatusId(null);
        setChangeStatusModal(false);
    };

    return (
        <>
            <ApplicationTab mainTabLabel="Other Application" />
            <OtherApplicationTab initialTabLabel="Address Change" />

            <Toast ref={toast} />
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={applicationsList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    rows={defaultRowOptions}
                                    paginator={applicationsList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Applications Found"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    removableSort
                                >
                                    {AddressChangeColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'add_status') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={statusTemplate} filter filterElement={searchByAppStatus} />;
                                        } else if (col.field === 'ApplicationDate') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={applicationDateTemplate} sortable style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'comment') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commentTemplate} style={{ maxWidth: '13rem' }} />;
                                        } else if (col.field === 'full_name') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={applicationsFullNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        } else if (col.field === 'verified_by') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={verifiedByTemplate} style={{ minWidth: '6rem' }} />;
                                        } else if (col.field === 'new_address') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={newAddressTemplate} />;
                                        } else if (col.field === 'RegNo') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} style={{ minWidth: '7rem' }} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                                {/* <Paginator first={first} rows={perPage} totalRecords={totalRecords} rowsPerPageOptions={defaultPageRowOptions} onPageChange={onPageChange} /> */}
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {AddressChangeColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Submit Application Dialog */}
            <Dialog
                visible={approveModal}
                className="p-fluid"
                style={{ width: '100vh' }}
                header={'Approve Application'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeApproveModal} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => onApproveApplication()} loading={approveLoader} />
                    </>
                }
                onHide={closeApproveModal}
            >
                <h5>Can You Submit This Application?</h5>
            </Dialog>

            {/* Change Status Modal */}
            <ApprovalModal id={changeStatusId} appName={ADDRESSCHANGENAME} visible={changeStatusModal} close={() => closeChangeStatusModal()} applicationName={ADDRESSCHANGENAME} />
        </>
    );
};
